import { makeAutoObservable, runInAction } from 'mobx';
import { message } from 'odc-shared/components';

import {
  CommPlatform,
  ModulePopularPostItem,
  ModuleSupportCenterCatalog,
} from '@src/api/generated/data-contracts';
import { getSupportCatalogs, getSupportPopular } from '@src/api/generated/Support';

class HelpCenterStore {
  // 目录结构数据 - 按平台区分
  catalogsByPlatform: Record<CommPlatform, ModuleSupportCenterCatalog[]> = {
    publisher: [],
    advertiser: [],
  };
  catalogsLoading: Record<CommPlatform, boolean> = {
    publisher: false,
    advertiser: false,
  };
  catalogsMap: Map<string, ModuleSupportCenterCatalog> = new Map();

  // 热门文章数据
  popularPosts: ModulePopularPostItem[] = [];
  popularPostsLoading = false;

  constructor() {
    makeAutoObservable(this);
  }
  /**
   * 获取目录树结构
   */
  async fetchCatalogs(platform: CommPlatform, rootOnly?: boolean, force = false) {
    if (!force && this.catalogsByPlatform[platform].length > 0) return;

    this.catalogsLoading[platform] = true;
    try {
      const response = await getSupportCatalogs({
        platform,
        root_only: rootOnly,
      });

      if (response.code === 0 && response.data?.catalogs) {
        runInAction(() => {
          this.catalogsByPlatform[platform] = response.data.catalogs?.[0].children || [];
        });
        this.setCatalogsMap(response.data.catalogs?.[0].children || []);
      } else {
        message.error(response.msg || 'Failed to fetch catalogs');
      }
    } catch (err) {
      console.error('获取目录数据失败:', err);
      message.error('Something went wrong. Please try again later.');
    } finally {
      runInAction(() => {
        this.catalogsLoading[platform] = false;
      });
    }
  }

  /**
   * 获取热门文章
   */
  async fetchPopularPosts(force = false) {
    if (!force && this.popularPosts.length > 0) return;

    this.popularPostsLoading = true;
    try {
      const response = await getSupportPopular();

      if (response.code === 0 && response.data?.items) {
        runInAction(() => {
          this.popularPosts = response.data.items || [];
        });
      } else {
        message.error(response.msg || 'Failed to fetch popular posts');
      }
    } catch (err) {
      console.error('获取热门文章失败:', err);
      message.error('Something went wrong. Please try again later.');
    } finally {
      runInAction(() => {
        this.popularPostsLoading = false;
      });
    }
  }

  setCatalogsMap(catalogs: ModuleSupportCenterCatalog[]) {
    catalogs.forEach((catalog) => {
      if (catalog.postId) {
        this.catalogsMap.set(catalog.postId!, catalog);
      } else {
        this.catalogsMap.set(catalog.id!, catalog);
      }
      this.setCatalogsMap(catalog.children || []);
    });
  }
}

export type HelpCenterStoreType = HelpCenterStore;

export default new HelpCenterStore();